import { Controller } from "@hotwired/stimulus"

// The subject and the body store a variable differently: the subject is
// rendered by substituting `{{key}}` tokens, the body by resolving sgid-backed
// ActionText attachments. So the insert target follows whichever field the user
// last focused, defaulting to the body.
export default class extends Controller {
  static targets = ["subject", "editor"]

  initialize() {
    this.lastFocused = "editor"
  }

  trackFocus(event) {
    if (this.hasSubjectTarget && this.subjectTarget.contains(event.target)) {
      this.lastFocused = "subject"
    } else if (this.hasEditorTarget && this.editorTarget.contains(event.target)) {
      this.lastFocused = "editor"
    }
  }

  insert(event) {
    const { variableToken, variableChip } = event.currentTarget.dataset

    if (this.lastFocused === "subject" && this.hasSubjectTarget) {
      this.insertIntoSubject(variableToken)
    } else if (this.hasEditorTarget) {
      // Lexxy's own update listener writes the new HTML into the element's form
      // value and dispatches `lexxy:change`, so the preview refresh is already
      // wired — dispatching it here too would only double the request.
      this.editorTarget.contents.insertHtml(variableChip)
    } else {
      console.warn("email-template-variables#insert: no editor target to insert into")
    }
  }

  insertIntoSubject(token) {
    const field = this.subjectTarget
    const start = field.selectionStart ?? field.value.length
    const end = field.selectionEnd ?? field.value.length

    field.value = `${field.value.slice(0, start)}${token}${field.value.slice(end)}`
    field.setSelectionRange(start + token.length, start + token.length)
    field.focus()
    field.dispatchEvent(new Event("input", { bubbles: true }))
  }
}
